import {useEffect, useState} from "react";
import {fetchJson} from "../fetch.js";
import * as BookPageHelpers from './helpers.js';
import * as Helpers from '../helpers.mjs';

import { useElasticData, useExtraData } from "./DataContext.js";

const BookPageClassSetOverlay = () => {
    const classSetOverlays = [
        "/assets/img/classSetOverlays/steel.png",
        "/assets/img/classSetOverlays/green.png",
        "/assets/img/classSetOverlays/aqua.png",
        "/assets/img/classSetOverlays/yellow.png",
        "/assets/img/classSetOverlays/red.png",
        "/assets/img/classSetOverlays/blue.png",
        "/assets/img/classSetOverlays/purple.png"
    ];

    const [randomClassSetOverlay, setRandomClassSetOverlay] = useState("");
    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * classSetOverlays.length);
        setRandomClassSetOverlay(classSetOverlays[randomIndex]);
    },[]);

    return (
        <div className="classSetOverlay">
            <img className="classSetOverlayImage" src={randomClassSetOverlay} alt="Class set offer" />
        </div>
    );
}

const BookPageImage = () => {
    let { elasticData } = useElasticData();
    let { extraData, _source, _index, isLibraryUser } = useExtraData();

    const bookpageEan13 = _source.id;

    const idx = _index;

    const isLibraryUserAndNotBookPack = (isLibraryUser() && (!idx.includes("dyn_book_packs") || !_source.isbookpack));

    const [bookPackLinks, setBookPackLinks] = useState([]);
    const [isBookPackLoading, setIsBookPackLoading] = useState(false);
    const [isSliderReady, setIsSliderReady] = useState(false);
    const [coverImageSrc, setCoverImageSrc] = useState("");
    const [offerMinQuantity, setOfferMinQuantity] = useState(extraData?.offerMinQuantity);
    const [alternateBookImages, setAlternateBookImages] = useState([]);

    useEffect(() => {
        setOfferMinQuantity(extraData?.offerMinQuantity);
        setIsBookPackLoading(false);
        setIsSliderReady(false);

        function setBookPageImages() {
            const imageLinks = BookPageHelpers.getBookImageLinks(bookpageEan13);

            if(Helpers.IsBooksForTopic(_source)) {
                setCoverImageSrc("/assets/img/booksForTopics.jpg");
            } else {
                setCoverImageSrc(imageLinks.cover);
            }

            setBookPackLinks([]);

            var alternateBookImageLinks = Object.entries(imageLinks).filter(i => i[0] != "cover");
            setAlternateBookImages(alternateBookImageLinks);
        }

        function setBookPackImages() {
            setCoverImageSrc("");
            setBookPackLinks([]);
            setAlternateBookImages([]);
            setIsBookPackLoading(true);

            fetchJson("/product/getBookPackImages/"+_source.id).then(r => {
                setBookPackLinks(r);
                setIsBookPackLoading(false);

                if (r.length == 1) {
                    const isBooksForTopicsPack = (_source.origin?.replace(/\W+/g, '').toLowerCase() == "booksfortopics");

                    if (isBooksForTopicsPack) {
                        setCoverImageSrc("/assets/img/booksForTopics.jpg");
                    } else {
                        const productImageSrc = Helpers.getProductImageLink(r[0].prEan13);
                        setCoverImageSrc(`${productImageSrc}`);
                    }
                }
            });
        }

        if (idx.includes("dyn_book_packs")) {
            setBookPackImages();
        } else if (!elasticData.isbookpack) {
            setBookPageImages();
        }
    }, [_source.product_id]);

    useEffect(() => {
        if (isBookPackLoading || bookPackLinks.length <= 1) return;

        if ($('#bookPackImages').hasClass('slick-slider')) {
            $('#bookPackImages').off('lazyLoaded');
            $("#bookPackImages").slick('unslick');
        }

        // Reveal the slider only once the first lazy image has actually loaded,
        // so the container always has real height before the skeleton is removed.
        $('#bookPackImages').one('lazyLoaded', function() {
            setIsSliderReady(true);
        });

        $('#bookPackImages').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false,
            draggable: true,
            lazyLoad: 'ondemand',
        });
    }, [bookPackLinks, isBookPackLoading]);

    useEffect(() => {
        if ($('#alternateBookImageContainer').hasClass('slick-slider')) {
            $("#alternateBookImageContainer").slick('unslick');
        }

        $('#alternateBookImageContainer').slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            dotsClass: "alternateImagesPagination",
            customPaging: function(slick,index) {
                return '<span class="alternateImagesPaginationBullet" tabindex="' + index + '" role="button" aria-label="Go to slide ' + (index + 1) + '"></span>';
            }
        });
    }, [alternateBookImages]);

    return (
        <>
            <div className={`bookPageImage${(offerMinQuantity > 1) ? " classSetOffer" : ""}`}>
                {/* Skeleton is in normal flow (provides height); slider is absolute (out of flow)
                    until the first image loads, then both swap in the same render */}
                {(isBookPackLoading || bookPackLinks.length > 1) && (
                    <div className="bookPackSlider">
                        {(isBookPackLoading || !isSliderReady) && <div className="bookPackImageSkeleton" />}
                        {!isBookPackLoading && bookPackLinks.length > 1 && (
                            <div className={isSliderReady ? '' : 'bookPackImagesLoading'}>
                                <div id="bookPackImages">
                                    {bookPackLinks.map((b, i) => <img key={i} className="bookPackItemImage bookImg" onError={(e) => {Helpers.handleImageError(e)}} data-lazy={BookPageHelpers.getBookImageLinks(b.prEan13).cover} />)}
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {!isBookPackLoading && bookPackLinks.length <= 1 && coverImageSrc !== "" && <>
                    <div className="image lightboxable"><img className="viewable frontcoverImage bookImg" onError={(e) => {Helpers.handleImageError(e)}} src={coverImageSrc} alt={_source.title} title={_source.title} /></div>
                    {offerMinQuantity > 1 && <BookPageClassSetOverlay />}
                </>}
                {(idx.includes("dyn_book_packs") || _source.isbookpack === 1) && <p className="bookPackDisclaimer"><em>Covers shown are representative of the contents of each pack, your selection may vary.</em></p>}
            </div>
            
            {alternateBookImages.length > 1 && <div key={bookpageEan13} id="alternateBookImageContainer" className="alternateImages">
                {/* <LoadingSpinner overlay={true} text="Checking for alternate images..." /> */}
                {alternateBookImages.map((i, k) => {
                    const imgType = i[0];
                    const imgLink = i[1];
                    return (
                        <div key={k} className="image lightboxable">
                            {imgType === "centerfold" && <img className="viewable centerfoldImage bookImg" onError={(e) => {Helpers.handleImageError(e)}} src={imgLink} alt="Centerfold image" title="Centerfold image" />}
                            {imgType === "backcover" && <img className="viewable backcoverImage bookImg" onError={(e) => {Helpers.handleImageError(e)}} src={imgLink} alt="Backcover image" title="Backcover image" />}
                            {imgType.startsWith("additional") && <img className="viewable additionalImage bookImg" onError={(e) => {Helpers.handleImageError(e)}} src={imgLink} alt="Additional image" title="Additional image" />}
                        </div>
                    );
                })}
            </div>}
            {isLibraryUserAndNotBookPack && <>
                <input id="showBookSize" name="showBookSize" type="checkbox"></input>
                <label className="showBookSizeLabel" htmlFor="showBookSize"></label>
            </>}
        </>
    );
}

export default BookPageImage;
